class BESSAppProjectBuildingClassCompositionChart extends BESSAppProjectChart {

    constructor() {
        super('app-chart-building-class-composition');
    }

    start() {
        if (this.isValid) {
            this.resProfiler = BESSApp.instance.managers.profilers.getProfiler('ResDwellingsEditor');
            this.nonResProfiler = BESSApp.instance.managers.profilers.getProfiler('NonResDwellingsEditor');
            this.#sync();
            this.subscribeToEvents(BESSAppProjectProfilersUpdatedEvent.name, this.#sync);
        }
    }

    #sync() {
        this.#buildBuildingClassComposition();
        this.log("Sync", this);
        if(this.buildingClassDataValid) {
            let chartData = [];
            _.forOwn(this.buildingClassComposition, function(value, key) {
                let name = key + ' - ' + value + ' total sqm';
                chartData.push([name, value]);
            });
            this._renderPieChart(chartData, )
        }
        this.chartView.showIf(this.buildingClassDataValid);
        let showBoth = this.chartView.parent().find('.app-chart:visible').length === 2;
        this.chartView.parent().addClassIf('show-both', showBoth);
        window.dispatchEvent(new Event('resize'));
    }

    #buildBuildingClassComposition() {
        this.totalBuildingClassArea = 0;
        this.buildingClassComposition = {};
        this.#buildBuildingClassCompositionFor(this.resProfiler);
        this.#buildBuildingClassCompositionFor(this.nonResProfiler);
        this.buildingClassDataValid = Object.keys(this.buildingClassComposition).length > 1 && this.totalBuildingClassArea > 0;
    }

    #buildBuildingClassCompositionFor(profiler) {
        if (profiler !== undefined) {
            this.forEach(profiler.data.items, function (space) {
                this.#buildBuildingClassCompositionForSpace(profiler, space);
            });
        }
    }
    #buildBuildingClassCompositionForSpace(profiler, space) {
        let buildingClassField = profiler.data.fields[profiler.data.getFieldNoForAttribute('type')];
        let buildingClass = space.values[profiler.data.getFieldNoForAttribute('type')].value;
        let quantity = space.values[profiler.data.getFieldNoForAttribute('quantity')].value;
        let area = space.values[profiler.data.getFieldNoForAttribute('area')].value;
        let totalArea = quantity * area;

        let buildingClassName = buildingClassField.choicesMap[buildingClass].value;
        if (!(buildingClassName in this.buildingClassComposition)) {
            this.buildingClassComposition[buildingClassName] = 0;
        }
        this.buildingClassComposition[buildingClassName] += totalArea;
        this.totalBuildingClassArea += totalArea;
    }
}